import { Grid, HueSlider, Text } from '@mantine/core';
import LabeledSlider from './LabeledSlider';

const AiModelPromptParametersSettings = ({ type, params, handleParamChange, model }) => {
  const modelIsGpt = model?.startsWith('gpt');

  return (
    <>
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>Temperature</label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }} pt="md">
          <LabeledSlider
            min={0}
            max={2}
            step={0.01}
            value={params[type]?.temperature}
            onChange={(temp) => handleParamChange(type, 'temperature', temp)}
          />
          <Text size="xs" c="dimmed" mt="xs">
            <strong>Low temperature</strong> (e.g. 0.1 - 0.4) produces more focused, conservative and deterministic
            output, useful for factual information or precise answers in a specific format.
            <br />
            <strong>Moderate temperature</strong> (e.g. 0.5 - 0.7) produces an output that is balanced between creative
            and consistent, useful for general content generation.
            <br />
            <strong>High temperature</strong> (e.g. 0.8 - 1) generates more diverse and unexpected outputs.
          </Text>
        </Grid.Col>
      </Grid>
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>Top P</label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <LabeledSlider
            min={0}
            max={1}
            step={0.01}
            value={params[type]?.top_p}
            onChange={(p) => handleParamChange(type, 'top_p', p)}
          />
          <Text size="xs" c="dimmed" mt="xs">
            A safe starting value is <strong>0.3</strong>.
            <br />
            Dynamically controls sampling by selecting tokens until their cumulative probability reaches and exceeds the
            specified threshold.
            <br />
            <strong>Low top_p</strong> utimately results in fewer token options and a more predictable output.
            <br />
            <strong>High top_p</strong> considers a wider range of token options and results in a more creative output.
          </Text>
        </Grid.Col>
      </Grid>
      {!modelIsGpt && (
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Top K</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <HueSlider
              min={1}
              max={100}
              step={1}
              value={params[type]?.top_k}
              onChange={(k) => handleParamChange(type, 'top_k', k)}
            />
            <Text size="xs" c="dimmed" mt="xs">
              A safe starting value is <strong>35</strong>.
              <br />
              Limits the sampling to the selected number of most probable tokens in each step of the generation.
              <br />
              <strong>Low top_k</strong> is a 'greedy' sampling strategy where only the highest probability tokens are
              considered which produces a strictly focused output.
              <br />
            </Text>
          </Grid.Col>
        </Grid>
      )}
    </>
  );
};
export default AiModelPromptParametersSettings;
